import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';
import getAdminObjectData from './getAdminObjectData';

export default ({
  adminObjectToExport,
  selectedAdminObject,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
  context: {
    categories,
  },
}) => {
  const adminObjectData = getAdminObjectData(selectedAdminObject);
  const sheetData = [{
    name: selectedAdminObject.value,
    type: SheetExportTypes.GRID,
    columnDefinitions: typeof adminObjectData.columnDefs === 'function'
      ? adminObjectData.columnDefs({ categories })
      : adminObjectData.columnDefs,
    data: adminObjectToExport,
    options: {
      shouldDisplayZero,
      hideDecimals,
      negativeMinus,
    },
  }];

  xlsxExport({
    sheetData,
    metadata: {
      fileName: adminObjectData.fileName,
      disableHeaderRendering: true,
    },
  });
};
